import {createSlice} from "@reduxjs/toolkit";

const initialGuideJjtuScholarsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  guideJjtuScholarForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};
export const guideJjtuScholarsSlice = createSlice({
  name: "guideJjtuScholars",
  initialState: initialGuideJjtuScholarsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getGuideJjtuScholarById
    guideJjtuScholarFetched: (state, action) => {
      state.actionsLoading = false;
      state.guideJjtuScholarForEdit = action.payload.guideJjtuScholarForEdit;
      state.error = null;
    },
    // findGuideJjtuScholars
    guideJjtuScholarsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // createGuideJjtuScholar
    guideJjtuScholarCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.guideJjtuScholar);
    },
    // updateGuideJjtuScholar
    guideJjtuScholarUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.guiJjtuScholarId === action.payload.guideJjtuScholar.guiJjtuScholarId) {
          return action.payload.guideJjtuScholar;
        }
        return entity;
      });
    },
    // deleteGuideJjtuScholar
    guideJjtuScholarDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.guiJjtuScholarId !== action.payload.guiJjtuScholarId);
    },
    // deleteGuideJjtuScholars
    guideJjtuScholarsDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.guiJjtuScholarId)
      );
    },
  }
});
